import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  name: "",
  model: "",
  plateNumber: "",
  driver: "",
  width: "",
  height: "",
  depth: "",
  trunkSize: "",
  image: [],
};

const vehicleFormSlice = createSlice({
  name: "vehicleForm",
  initialState,
  reducers: {
    setVehicleForm: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetVehicleForm: () => initialState,
  },
});

export const { setVehicleForm, resetVehicleForm } = vehicleFormSlice.actions;
export default vehicleFormSlice.reducer;
